// ----------------------------------------------------------------------------
// Section: Image with Text (content panel)
// ----------------------------------------------------------------------------

import 'snippets/video-player/video-block';
import './_image-with-text.scss';
var ROOT = '[data-content-panel-video-root]';
var VIDEO_BLOCK = '.video-block';
var playEvent = new Event('play.video-block');
var pauseEvent = new Event('pause.video-block');
function initContentPanelVideo() {
  var roots = document.querySelectorAll(ROOT);
  roots.forEach(root => {
    var block = root.querySelector(VIDEO_BLOCK);
    var html5 = root.querySelector('video.video-block__video');
    var mediaHost = block === null || block === void 0 ? void 0 : block.querySelector('.video-block__video');
    if (!block) {
      return;
    }
    var observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          block.dispatchEvent(playEvent);
          mediaHost === null || mediaHost === void 0 || mediaHost.removeAttribute('inert');
        } else {
          block.dispatchEvent(pauseEvent);
          mediaHost === null || mediaHost === void 0 || mediaHost.setAttribute('inert', '');
        }
      });
    }, {
      threshold: 0.35
    });
    observer.observe(root);
    if (html5) {
      html5.addEventListener('error', () => {
        root.classList.add('content-panel__media-root--video-failed');
      });
    }
  });
}
document.addEventListener('DOMContentLoaded', initContentPanelVideo);